import React from 'react'
import { RegisterPageWrapper } from './RegisterPageStyled'
import { Statistic } from 'antd'
import { useParams } from 'react-router-dom'
import { REGISTER_ID, STATION_TYPE, VIEW_MODE } from '../../constant'
import RegisterForm from '../../components/RegisterForm'
import { useRecoilValue } from 'recoil'
import { pageConfigRealState, pageStatusState } from '../../recoil/landingPageState'
import Maintain from '../../components/Maintain/Maintain'

const { Countdown } = Statistic

const RegisterPage = props => {
  const { id: registerType } = useParams()
  const pageConfig = useRecoilValue(pageConfigRealState)
  const pageStatus = useRecoilValue(pageStatusState)

  const renderByType = () => {
    switch (registerType) {
      case REGISTER_ID.CASH_FLOW:
        return (
          <RegisterForm
            pageConfig={pageConfig}
            mode={VIEW_MODE.PUBLIC}
            registerType={registerType}
            stationType={STATION_TYPE.BUSINESS}
          />
        )
      case REGISTER_ID.ECOMMERCE:
        return (
          <RegisterForm
            pageConfig={pageConfig}
            mode={VIEW_MODE.PUBLIC}
            registerType={registerType}
            stationType={STATION_TYPE.ECOMMERCE}
          />
        )
      case REGISTER_ID.FINANCE:
        return (
          <RegisterForm
            pageConfig={pageConfig}
            mode={VIEW_MODE.PUBLIC}
            registerType={registerType}
            stationType={STATION_TYPE.FINANCE}
          />
        )
      case REGISTER_ID.KNOWLEDGE:
        return (
          <RegisterForm
            pageConfig={pageConfig}
            mode={VIEW_MODE.PUBLIC}
            registerType={registerType}
            stationType={STATION_TYPE.KNOWLEDGE}
          />
        )
      default:
        return
    }
  }

  return <>
    {
      pageStatus.status === 'ON'
        ? <RegisterPageWrapper>{renderByType()}</RegisterPageWrapper>
        : pageStatus.status === 'OFF'
          ? <Maintain />
          : <></>
    }
  </>
}

RegisterPage.propTypes = {}

export default RegisterPage
